import React from 'react';
import {
    Navigate, Route, Routes, useParams,
} from 'react-router-dom';
import { PortfolioOverviewProvider } from 'domain/Portfolio';
import { getClientId } from 'utils';
import PortfolioActionsRouter from './PortfolioActionsRouter';
import withActionAccess from './hocs/withActionAccess';

import SinglePortfolioRouter from './pages/SinglePortfolioView/SinglePortfolioRouter';

const CachedPortfolioActionsRouter = withActionAccess(PortfolioActionsRouter);

const PortfolioRouter = () => {
    const { dfsClientId, portfolioId } = useParams();
    const clientId = getClientId(dfsClientId);

    return (
        <PortfolioOverviewProvider
            options={{
                id: Number(portfolioId),
                clientId: Number(clientId),
                portfolio: { loadInitially: true },
            }}
        >
            <Routes>
                <Route path="tab/*" element={<SinglePortfolioRouter />} />
                <Route path="*" element={<CachedPortfolioActionsRouter />} />
                <Route
                    path=""
                    element={<Navigate to="tab" replace />}
                />
                <Route
                    path="*"
                    element={<Navigate to="/404" replace />}
                />
            </Routes>
        </PortfolioOverviewProvider>
    );
};

PortfolioRouter.displayName = 'PortfolioRouter';

export default PortfolioRouter;
